export default __webpack_public_path__ + "static/media/curtains-padding.484220a6.png";